export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/modals-services-provider/index.ts"